// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1844":"be227f85","1874":"a41521a4","2306":"be227f85","4993":"0856e088","7094":"a41521a4","7992":"a41521a4","8511":"a41521a4","9826":"0e0aa22c"}[chunkId] + ".chunk.css";
};